import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91cd6c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-assigned-working-sites-section" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-section-spacing bg-white z-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Cantieri")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "working-sites-users w-full"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"titles-working-site-users grid grid-cols-5\" data-v-91cd6c7a><p class=\"first text-left\" data-v-91cd6c7a>Nome cantiere</p><p class=\"secon text-left\" data-v-91cd6c7a>Ruolo assegnato</p><p class=\"third text-left\" data-v-91cd6c7a>Data assegnazione</p><div class=\"fourth\" data-v-91cd6c7a></div></div>", 1)
const _hoisted_6 = { class: "users-list list overflow-y-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAssignedWorkingSite = _resolveComponent("UserAssignedWorkingSite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.assignedWorkingSites)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignedWorkingSites, (workingSite) => {
                return (_openBlock(), _createBlock(_component_UserAssignedWorkingSite, { "model-value": workingSite }, null, 8, ["model-value"]))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}